import { Box, Skeleton } from '@rbilabs/universal-components';

import {
  ProductSkeletonCardContainer,
  ProductSkeletonCardWrapper,
  ProductSkeletonCards,
  SkeletonCard,
  SkeletonCardContent,
} from './styled';

const SKELETON_CARDS_COUNT = 3;

export const ProductSkeletonCard = () => {
  return (
    <ProductSkeletonCardWrapper>
      <ProductSkeletonCardContainer>
        <Skeleton width="1/3" h="$4" rounded="full" marginX="$2" />
        <ProductSkeletonCards>
          {Array.from({ length: SKELETON_CARDS_COUNT }).map((_, index) => (
            <SkeletonCard key={index}>
              <SkeletonCardContent>
                <Box flex={1}>
                  <Skeleton width="full" h="$4" rounded="md" flex={1} />
                </Box>
                <Box height="50px" justifyContent="space-around" alignItems="center">
                  <Skeleton width="1/2" h="$4" rounded="md" />
                  <Skeleton width="full" h="$4" rounded="md" />
                </Box>
              </SkeletonCardContent>
            </SkeletonCard>
          ))}
        </ProductSkeletonCards>
      </ProductSkeletonCardContainer>
    </ProductSkeletonCardWrapper>
  );
};
